import PropTypes from 'prop-types';
import React, { useState } from 'react';
import styled from 'styled-components';

import InputStandard from '@components/InputStandard';

import RecentAlertList from './RecentAlertList';
const RECENT_ALERT_IDS = '__RECENT_ALERT_IDS__';

// TODO dry this up
const getItem = () => {
  let data = [];
  try {
    data = JSON.parse(localStorage.getItem(RECENT_ALERT_IDS));
  } catch (e) {
    console.error('Could not parse localStorage for recent alert IDs', e);
  }
  if (!Array.isArray(data)) return [];
  return data.filter(item => item.id);
};

const InputContainer = styled.div`
  align-items: center;
  border-radius: 4px;
  color: ${props => props.theme.primary};
  display: flex;
  flex: 1;
  margin: 0;
  margin-right: 15px;
  min-width: 200px;
  padding: 5px;
  position: relative;
  z-index: 3;
  
  @media ${props => props.theme.device.portrait} {
    margin-right: 0px;
    margin-top: ${props => props.theme.gutter};
    margin-bottom: ${props => props.theme.gutter};
  }

  form {
    display: inline-block;
    width: 100%;
    max-height: 64px;
    overflow: visible;
  }
`;

const ComponentContainer = styled.div`
  margin: 10px;
`;

const Overflow = styled.div`
  border-radius: 0px 0px 5px 5px;
  border: ${props => props.theme.borderMd};
`;

const RowContainer = styled.div`
  width: 100%;
  display: flex;
  padding: 10px 5px 0px;
  margin: 10px 5px 0px;
  flex-wrap: wrap;
  align-items: center;
  svg {
    padding: 0px 5px 0 10px;
    &:hover {
      cursor: pointer;
    }
  }
  button {
    &:hover {
      cursor: pointer;
    }
  }
`;

const withAlerts = {
  marginBottom: '0px',
  borderBottom: 'none',
  borderRadius: '3px 3px 0 0',
};

const AlertLookup = ({ search, setSearch }) => {
  const handleChange = e => setQuery(e);

  const [query, setQuery] = useState('');
  const [hasFocus, setHasFocus] = useState(false);

  const onSubmitQuery = e => {
    let finalQuery = '';
    if (typeof e === 'string') {
      finalQuery = query || e;
      setSearch(finalQuery);
      setQuery(finalQuery);
    } else {
      e.preventDefault();
      finalQuery = query;
    }

    if (finalQuery === '') {
      setSearch({});
      return;
    }

    setSearch(finalQuery);
  };

  let alerts = [];
  let localAlerts = getItem();
  if (localAlerts && localAlerts.length > 0 && (!query || query.length === 0)) {
    alerts = localAlerts;
  }

  const onClickAlert = aId => {
    setQuery(aId);
    onSubmitQuery(aId);
  };

  const hasAlerts = alerts && alerts.length > 0;
  return (
    <ComponentContainer>
      <RowContainer>
        <InputContainer>
          <form
            onSubmit={e => {
              e.preventDefault();
              onSubmitQuery(query);
            }}
          >
            <InputStandard
              optional
              onBlur={() => setHasFocus(false)}
              onClick={() => setHasFocus(true)}
              style={hasAlerts && hasFocus ? withAlerts : {}}
              value={query}
              onChange={handleChange}
              placeholder='Lookup Decision ID#'
            />
            {hasAlerts && hasFocus && (
              <Overflow>
                <RecentAlertList list={alerts} onClickAlert={onClickAlert} />
              </Overflow>
            )}
          </form>
        </InputContainer>
      </RowContainer>
    </ComponentContainer>
  );
};

AlertLookup.propTypes = {
  query: PropTypes.string.isRequired,
  setQuery: PropTypes.func.isRequired,
  setSearch: PropTypes.func.isRequired,
};

export default AlertLookup;
